/**
 * AccessImageContainer component.
 */
import FlavourConfig from '@shared/config/flavours';
import styled from 'styled-components';

/**
 * Styled access image container.
 */
const AccessImageContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: ${() =>
    `url(${FlavourConfig.images.access || FlavourConfig.images.background})`};
`;

export default AccessImageContainer;
